module.exports = __webpack_public_path__ + "img/about@3x.92adb485.jpg";